import React, {useCallback, useEffect, useState} from 'react';
import {Box, Fade, Modal, Typography} from "@mui/material";
import Backdrop from '@mui/material/Backdrop';
import {global, input, short, shortFunction} from "../translate";
import {useSelector} from "react-redux";
import Api from "../Api";
import CloseIcon from "@mui/icons-material/Close";
import { encodeFamiliarDuration, decodeFamiliarDuration } from "../helpers/familiarDuration";

import {style} from "../helpers/style";

function EditShortFunction({open, setOpen, all,have}) {
    const [form, setForm] = useState('')
    const [durationUnit, setDurationUnit] = useState('days')
    const [types,setTypes] = useState({
        in_type:have?all.find(s => s.function_code === open)?.in_type:0,
        out_type:have?all.find(s => s.function_code === open)?.out_type:0,
    })
    const userData = useSelector((state) => state.users.userData)
    useEffect(() => {
        const row = have ? all.find(s => s.function_code === open) : null
        if (+open === 10999 && row) {
            const decoded = decodeFamiliarDuration(row)
            setForm(decoded.durationValue)
            setDurationUnit(decoded.durationUnit)
        } else {
            setForm(row?.day_count ?? '')
            setDurationUnit('days')
        }
    },[all,open, have])
    const [selectedValue, setSelectedValue] = useState(have?all.find(s => s.function_code === open)?.status ?? 0:0);

    useEffect(() => {
        const current = have ? all.find(s => s.function_code === open) : null;
        setSelectedValue(current?.status ?? 0);
    }, [have, all, open])

    const handleAdd = useCallback(async () => {
        try {
            let formData = {}
            formData = {
                familiar_client: all[0]?.day_count || 3,
                ending_call: all[1]?.day_count|| 3,
                voice_mail: all[2]?.day_count|| 3,
                sip_operator_mail: all[3]?.day_count || 3,
            }
            all.map(s => {
                console.log(s)
                if (+open === 10999 && +s.function_code === +open) {
                    formData = {...formData,id:s.id, 'familiar_client': form,type:'familiar_client'}
                } else if (+open === 10888 && +s.function_code === +open) {
                    formData = {...formData,id:s.id, 'ending_call': form,type:'ending_call'}
                } else if (+open === 100097 && +s.function_code === +open){
                    formData = {...formData,id:s.id, 'voice_mail': form,type:'voice_mail'}
                } else if (+open === 100098 && +s.function_code === +open){
                    formData = {...formData,id:s.id, 'sip_operator_mail': form,type:'sip_operator_mail'}
                }
            })
            let day = form
            let duration_hours = null
            if (+open === 10999) {
                const encoded = encodeFamiliarDuration(form, durationUnit)
                day = encoded.day_count
                duration_hours = encoded.duration_hours
            }
            formData = {...formData, member: userData.id, status: selectedValue, ...types, day, duration_hours}
            await Api.shortFunctionEdit(formData)
            window.location.reload()
            setOpen('')
        }catch (e) {
            console.log(e)
        }
    }, [form, userData, types,all,selectedValue])
    const options = [short.in[+localStorage.getItem('atsLang') || 1], short.out[+localStorage.getItem('atsLang') || 1], short.both[+localStorage.getItem('atsLang') || 1]];
    const handleCheckboxChange = (index) => {
        setSelectedValue(prev => (prev === index ? null : index));
    };
    const handleCheckboxChange1 = (name,val) => {
        setTypes(prev => ({...prev,[name]:val}));
    };

    return (
        <Modal
            aria-labelledby="transition-modal-title"
            aria-describedby="transition-modal-description"
            open={!!open}
            onClose={() => setOpen(false)}
            closeAfterTransition
            slots={{backdrop: Backdrop}}
            slotProps={{
                backdrop: {
                    timeout: 500,
                },
            }}
        >
            <Fade in={!!open}>
                <Box sx={style}>
                    <div className="d-flex flex-row justify-content-between">
                        <Typography id="transition-modal-title" variant="h6" component="h2">
                            Short function
                        </Typography>
                        <span style={{cursor: 'pointer'}} onClick={() => setOpen(false)}>
                                                         <CloseIcon/>

                        </span>
                    </div>
                    <div className="row" style={{margin: '30px 0'}}>
                        {+open === 10999 && (
                            <div style={{ marginBottom: 12, display: 'flex', gap: 8 }}>
                                <button type="button" className={durationUnit === 'hours' ? 'addBtn' : ''} onClick={() => setDurationUnit('hours')}>
                                    {global.hour[+localStorage.getItem('atsLang') || 1]}
                                </button>
                                <button type="button" className={durationUnit === 'days' ? 'addBtn' : ''} onClick={() => setDurationUnit('days')}>
                                    {global.day[+localStorage.getItem('atsLang') || 1]}
                                </button>
                            </div>
                        )}
                        <label style={{margin: '20px 0'}} className="count">
                            <span>
                               {(+open === 10999 && durationUnit === 'hours' ? global.hour : global.day)[+localStorage.getItem('atsLang')  || 1]} :
                            </span>
                            <input
                                type="number"
                                min={+open === 10999 && durationUnit === 'hours' ? 1 : 0}
                                max={+open === 10999 && durationUnit === 'hours' ? 23 : 30}
                                value={form}
                                onChange={(ev) => setForm(ev.target.value)}
                            />
                        </label>
                    </div>
                    {(+open === 100097 || +open === 100098) && (
                        <div style={{marginBottom: 20}}>
                            <p className="text-center" style={{margin:'10px 0'}}><b>Status</b></p>
                            <div className="d-flex justify-content-center align-items-center" style={{gap: 10}}>
                                <label className="toggle" style={{margin: 0}}>
                                    <input
                                        type="checkbox"
                                        checked={selectedValue === 1}
                                        onChange={() => setSelectedValue(prev => prev === 1 ? 0 : 1)}
                                    />
                                    <span className="toggle-slider"/>
                                </label>
                                <span className={`short-card__status-label ${selectedValue === 1 ? 'is-active' : 'is-inactive'}`}>
                                    {selectedValue === 1 ? shortFunction.status[localStorage.getItem('atsLang') || 1] : shortFunction.in_status[localStorage.getItem('atsLang') || 1]}
                                </span>
                            </div>
                        </div>
                    )}
                    {+open !== 100097 && (
                        <>
                            <div className="d-flex justify-content-around">
                                {
                                    options.map((label, index) => (
                                        <label key={index} style={{ display: 'block', marginBottom: '8px' }}>
                                            <input
                                                type="checkbox"
                                                checked={selectedValue === index}
                                                onChange={() => handleCheckboxChange(index)}
                                            />
                                            <span style={{marginLeft:10}}>{label}</span>
                                        </label>
                                    ))
                                }
                            </div>

                            {selectedValue !== 2?<div >
                                <hr/>
                                <p className="text-center" style={{margin:'20px 0'}}><b>Disposition</b></p>
                                <div className="d-flex justify-content-around">
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedValue === 0?!types.in_type:!types.out_type}
                                            onChange={(ev) => handleCheckboxChange1(selectedValue === 0?'in_type':'out_type',0)}
                                        />
                                        <span style={{marginLeft:10}}>{global.only[+localStorage.getItem('atsLang')  || 1]}</span>
                                    </label>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <input
                                            type="checkbox"
                                            checked={selectedValue === 0?types.in_type:types.out_type}
                                            onChange={(ev) => handleCheckboxChange1(selectedValue === 0?'in_type':'out_type',1)}
                                        />
                                        <span style={{marginLeft:10}}>{global.all[+localStorage.getItem('atsLang')  || 1]}</span>
                                    </label>
                                </div>


                            </div>:
                                <div >
                                <hr/>
                                <p className="text-center" style={{margin:'20px 0'}}><b>Disposition</b></p>
                                    <p className="text-center" style={{margin:'20px 0'}}><b>For Incoming</b></p>

                                    <div className="d-flex justify-content-around">
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <input
                                            type="checkbox"
                                            checked={!types.in_type}
                                            onChange={(ev) => handleCheckboxChange1('in_type',0)}
                                        />
                                        <span style={{marginLeft:10}}>{global.only[+localStorage.getItem('atsLang')  || 1]}</span>
                                    </label>
                                    <label style={{ display: 'block', marginBottom: '8px' }}>
                                        <input
                                            type="checkbox"
                                            checked={types.in_type}
                                            onChange={(ev) => handleCheckboxChange1('in_type',1)}
                                        />
                                        <span style={{marginLeft:10}}>{global.all[+localStorage.getItem('atsLang')  || 1]}</span>
                                    </label>
                                </div>
                                    <p className="text-center" style={{margin:'20px 0'}}><b>For Outgoing</b></p>

                                    <div className="d-flex justify-content-around">
                                        <label style={{ display: 'block', marginBottom: '8px' }}>
                                            <input
                                                type="checkbox"
                                                checked={!types.out_type}
                                                onChange={(ev) => handleCheckboxChange1('out_type',0)}
                                            />
                                            <span style={{marginLeft:10}}>Answered</span>
                                        </label>
                                        <label style={{ display: 'block', marginBottom: '8px' }}>
                                            <input
                                                type="checkbox"
                                                checked={types.out_type}
                                                onChange={(ev) => handleCheckboxChange1('out_type',1)}
                                            />
                                            <span style={{marginLeft:10}}>The other</span>
                                        </label>
                                    </div>

                            </div>}
                        </>
                    )}

                    <div className="d-flex justify-content-center" style={{marginTop: 20}}>
                        <button onClick={handleAdd} className="addBtn">
                            {global.edit[+localStorage.getItem('atsLang')  || 1]}
                        </button>
                    </div>
                </Box>
            </Fade>
        </Modal>
    );
}

export default EditShortFunction;
